import styles from './style.module.css';
import { useState } from 'react';

export default function ContactBtn(){
    const [isCopy,setIsCopy]=useState(false);
    const contact="samuel_admin@samsung.com";

    const handleCopy=()=>{
        navigator.clipboard.writeText(contact)
        .then(()=>{
            setIsCopy(true)
            setTimeout(() => {
                setIsCopy(false);
            }, 2000);
        })
        .catch(err=>console.error('copy fail:',err))
    }

    return(
        <div className={styles['wrap']}>
            <div className={styles['text']}>
                <span>
                    Contact to
                    <br></br>
                    {contact}
                </span>
            </div>
            <div className={styles['copy-btn']} onClick={handleCopy}></div>
            {isCopy&&<div className={styles['copy-btn-effect']}>See you soon!</div>}
        </div>
    )
}